export default "__VITE_ASSET__15d8cdba__"